/**
 * Menu `slotProps` shared by the Track filter menus that hold their own form
 * (rating, finish date, release year): a shadowed paper with a pointer
 * connecting it to the chip or button that opened it.
 */
export const filterMenuSlotProps = {
  paper: {
    elevation: 0,
    sx: {
      overflow: "auto",
      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
      mt: 1.5,
      "&::before": {
        content: '""',
        display: "block",
        position: "absolute",
        top: 0,
        left: 14,
        width: 10,
        height: 10,
        bgcolor: "background.paper",
        transform: "translateY(-50%) rotate(45deg)",
        zIndex: 0,
      },
    },
  },
};
